import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSidebarToggle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.5,
		y: 1.5,
		width: 15,
		height: 15,
		rx: 2.5,
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("line", {
		x1: 6,
		y1: 1.5,
		x2: 6,
		y2: 16.5,
		stroke: "currentColor",
		strokeWidth: 1.5
	})]
});
export { SvgIconSidebarToggle as ReactComponent };
